<template>
<div class="navbar">
  <div class="navbar-section">
    <router-link to="/about" class="navbar-item">Marcia Halperin Pottery</router-link>
    <router-link to="/gallery" class="navbar-item ">Gallery</router-link>
  </div>
  <div class="navbar-section">
    <router-link to="/contact" class="navbar-item">Contact</router-link>
  </div>
</div>
</template>

<script>
export default {
  name: 'navbar',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar-section {
  display: flex;
}
.navbar {
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: space-between;
  padding: 0 1em 0 1em;
  border-bottom: 1px solid #eee;
}
.navbar-item {
  padding: 0.75em 0.75em 0.75em 0.75em;
  cursor: pointer;
  user-select: none;
  color: #33a;
  text-decoration: underline;

  font-size: 1.2rem;

  &.router-link-active {
    background: $background;
    font-weight: 700;
    color: black;
    text-decoration: initial;
  }

  &:hover {
    background: $background;
  }
}
a {
  text-decoration: initial;
  color: $text-base;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue?17ee2ad4